/* ============================================================
   TRAVERTIN — hero gallery zoom (click an image → full-screen lightbox).
   Standalone & self-contained so it can load alongside the main module.
   Idempotent; re-runs on shopify:section:load (Theme Editor).
   ============================================================ */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function openLb(lb) { lb.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; }
  function closeLb(lb) { lb.classList.remove('is-open'); document.documentElement.style.overflow = ''; }

  function init(root) {
    root = root || document;
    $$('.tvn-carousel--gallery', root).forEach(function (gal) {
      if (gal.dataset.tvnZoom === '1') return;
      gal.dataset.tvnZoom = '1';
      var imgs = $$('.tvn-carousel__track img', gal);
      var lb = $('#tvn-gallery-lightbox');
      if (!imgs.length || !lb) return;
      var lbImg = $('[data-tvn-lightbox-img]', lb);
      var srcs = imgs.map(function (im) { return im.getAttribute('data-full') || im.src; });
      var idx = 0;
      var show = function (i) { idx = (i + srcs.length) % srcs.length; if (lbImg) lbImg.src = srcs[idx]; };

      imgs.forEach(function (im, k) {
        im.style.cursor = 'zoom-in';
        im.addEventListener('click', function () { show(k); openLb(lb); });
      });

      if (lb.dataset.tvnZoomWired !== '1') {
        lb.dataset.tvnZoomWired = '1';
        $$('[data-tvn-modal-close], .tvn-modal__overlay', lb).forEach(function (c) {
          c.addEventListener('click', function () { closeLb(lb); });
        });
        var prev = $('[data-tvn-lightbox-prev]', lb), next = $('[data-tvn-lightbox-next]', lb);
        if (prev) prev.addEventListener('click', function (e) { e.stopPropagation(); show(idx - 1); });
        if (next) next.addEventListener('click', function (e) { e.stopPropagation(); show(idx + 1); });
        document.addEventListener('keydown', function (e) {
          if (!lb.classList.contains('is-open')) return;
          if (e.key === 'Escape') closeLb(lb);
          else if (e.key === 'ArrowLeft') show(idx - 1);
          else if (e.key === 'ArrowRight') show(idx + 1);
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else { init(document); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
